<template>
  <div class="tabbar-box">
    <div class="tabbar-item">
      <div class="within" @click="goTabbar(0)">
        <van-icon name="todo-list-o" size="36" :color="isOneActive? '#2eaeb4' : '#bfbfbf'"/>
        <span :style="{color: isOneActive? '#2eaeb4' : '#dfdfdf'}">项目</span>
      </div>
    </div>
    <div class="tabbar-item">
      <div class="within" @click="goTabbar(1)">
        <van-icon name="friends-o" size="36" :color="isTwoActive? '#2eaeb4' : '#bfbfbf'"/>
        <span :style="{color: isTwoActive? '#2eaeb4' : '#dfdfdf'}">我的</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabbar',
  props: {
    isOneActive: {
      type: Boolean,
      default: false
    },
    isTwoActive: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
    }
  },
  methods: {
    goTabbar(index) {
      switch(index) {
        case 0:
          if(this.$route.name == 'Index') {
            return false;
          }
          this.$router.push({
            name: 'Index'
          })
          break;
        case 1:
          if(this.$route.name == 'My') {
            return false;
          }
          this.$router.push({
            name: 'My'
          })
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tabbar-box{
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 60px;
  z-index: 998;
  border-top: 1px solid #dfdfdf;
  display: flex;
  align-items: center;
  .tabbar-item{
    flex: 1;
    height: inherit;
    .within{
      height: inherit;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-direction: column;
      span{
        font-size: 16px;
      }
    }
  }
}
</style>